import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';

import classes from 'classnames';

import styles from './grid.css';

const { div } = hh(h);

const Grid = ({
    classNames = [],
    ...props
}) =>
          div({className: classes(styles.grid, ...classNames)}, props.children);

export default Grid;



/** WEBPACK FOOTER **
 ** ./src/Grid/index.js
 **/